import baseAddDatapointConfig from 'owa-analytics-actions/lib/addDatapointConfig';
import type { DatapointConfig } from 'owa-analytics-types';
import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';

export type DatapointConfigWithoutMailbox = Omit<DatapointConfig, 'mailbox'>;

export function addDatapointConfig<TMessage>(
    config: DatapointConfigWithoutMailbox,
    actionMessage: TMessage
): TMessage {
    const { name, ...datapointConfig } = config;

    return baseAddDatapointConfig(name, getUserMailboxInfo(), datapointConfig, actionMessage);
}
